import useGetUserOrdersAmount from './useGetUserOrdersAmount'

export default useGetUserOrdersAmount
